module.exports = __webpack_public_path__ + "img/4-3-3.0bc26c2a.png";